import baseAPI from '@/http'

const router = 'api/municipio/membrogrupo'

export const memberGroupAPI = {
  create: (memberGroup) => baseAPI.post(router, memberGroup),
  update: (memberGroup) => baseAPI.put(router, memberGroup),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router)
}
